import { useContext } from 'react'
import { RecurlyContext } from './RecurlyProvider'


const useRecurly = () => {
  const context = useContext(RecurlyContext)

  if (!context?.elements) {
    throw new Error(
      `It looks like you are trying to use Recurly outside of RecurlyProvider`
    )
  }

  return context
}


export default useRecurly
